export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to continue?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Crypto Asset"])}
}